import React, {useEffect, useState} from "react";
import axios from "axios";
import * as constants from "../constants/domains";
import {toast} from "react-toastify";
import {useCookies} from "react-cookie";
import Loading from "./ui/Loading";
import {Link} from "react-router-dom";

export default function Header () {

    const [userLoading, setUserLoading] = useState(false);
    const [user , setUser] = useState({})

    const Cookie = useCookies(['user_server_token']);
    const cookies = Cookie[0];
    const removeCookie = Cookie[2];

    const {user_server_token} = cookies;
    useEffect(() => {
        setUserLoading(true)
        axios.post(constants.$apiUrl + '/api/check-token', [],{
            headers: {
                "Authorization": "Bearer " + user_server_token,
                'Access-Control-Allow-Origin': '*',
                'Content-type': 'application/json',
            }
        })
            .then((response) => {
                setUser({...response.data.data})
                setUserLoading(false)
            })
            .catch((err) => {
                if (err.response && err.response.status === 401) {
                    console.log(401)
                } else {
                    toast.error('مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                }
                setUserLoading(false)

            })

    }, [user_server_token])


    const logout = () => {
        setUserLoading(true);
        axios.post(constants.$apiUrl+'/api/logout' , [] , {
            headers : {
                Authorization : "Bearer "+cookies.user_server_token
            }
        })
            .then((response) => {
                if(response.data.success){
                    removeCookie("user_server_token" , { domain: constants.$cookieURL ,path: '/' });
                    window.location.replace(constants.$shopUrl);
                } else {
                    toast.error('مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                }
                setUserLoading(false);

            })
            .catch(() => {
                toast.error('مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                setUserLoading(false);

            })
    }


    return (
        <React.Fragment>
            {userLoading ? <Loading /> : null}
            <header className="header text-right dir-rtl shadow-sm position-relative">
                <div className="d-none d-lg-block">
                    <div className="header-wrapper container-fluid pt-3 px-4">
                        <div className="row">
                            <div className="col-lg-4"><a className="d-inline-flex" href={constants.$shopUrl}>
                                <img width="55" height="55"
                                     src={constants.$authUrl+"/images/icon/506bd908fac6e6cb98e0527e2878d0f7.png"}
                                     alt="" />
                                <div className="d-flex flex-column pe-2 align-self-end"><span
                                    className="logo-title">هـنـری</span><span
                                    className="logo-subtitle">تحقق رویای هنرمندانه‌ ی تو</span></div>
                            </a></div>
                            <div className="col-lg-8 ">
                                <nav className="main-menu-nav">
                                    <ul className="main-menu">
                                        <li className="has-dropdown">
                                            {/*<a className={"cursor-pointer"} href={user.name ? null : constants.loginURL+"?site=class&callBack="+encodeURIComponent(url) }>*/}
                                            <span className={"cursor-pointer"} >
                                                <img src={constants.$authUrl+"/images/icon/20c1062c46f7cc30134ace3cc3823f3e.png"} width="30" height="30" alt="" />
                                                <span  className={'me-2 nav-item'}>
                                        { user.name ?
                                            user.name :
                                            'ورود/ثبت نام'
                                        }
                                    </span>
                                                {
                                                    user.id ?
                                                        <span className="arrow-down">
                                                        <svg width="10" height="7"
                                                             viewBox="0 0 10 7" fill="none"
                                                             xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M9.65377 0.657667C9.6553 0.748513 9.65834 0.930204 9.57724 1.02254L4.95448 6.28578L0.158324 1.1926C-0.00996184 1.0139 -0.0145251 0.74136 0.147677 0.556685C0.309879 0.37201 0.557745 0.367534 0.726031 0.546242L4.93319 5.01394L8.98823 0.397064C9.15044 0.212389 9.3983 0.207914 9.56659 0.386622C9.65073 0.475976 9.65225 0.566821 9.65377 0.657667Z" fill="black" />
                                                        </svg>
                                                    </span>
                                                        : null
                                                }
                                            </span>
                                            { user.id ?
                                                <ul className="submenu">
                                                    <li>
                                                        <p>{user.name}</p>
                                                        <p>{user.username}</p>
                                                        <Link style={{padding: '5px 15px',
                                                            backgroundColor: '#2ccbcc',
                                                            borderRadius: 3,
                                                            color: 'white',
                                                            width: '100%',
                                                            marginRight : 0,
                                                        }} to={"/user/edit"} >
                                                            اطلاعات حساب من
                                                        </Link>
                                                    </li>
                                                    <hr className={"solid mb-3"} />
                                                    <li>
                                                        <span onClick={logout} className={"cursor-pointer"} >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                                 fill="currentColor" className="bi bi-file-x" viewBox="0 0 16 16">
                                                                <path d="M6.146 6.146a.5.5 0 0 1 .708 0L8 7.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 8l1.147 1.146a.5.5 0 0 1-.708.708L8 8.707 6.854 9.854a.5.5 0 0 1-.708-.708L7.293 8 6.146 6.854a.5.5 0 0 1 0-.708z" />
                                                                <path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z" />
                                                            </svg>
                                                            &nbsp;&nbsp;
                                                            خروج از حساب کاربری
                                                        </span>
                                                    </li>
                                                </ul>
                                                : null
                                            }
                                        </li>
                                    </ul>

                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-lg-none">
                    <div className="d-flex pe-2 justify-content-between mobile-header-wrapper align-items-center">
                        <div><a  href={constants.$shopUrl}><img className="mobile-header-logo"
                                                                src={constants.$authUrl+"/images/icon/dff2b09fc8652c271c07b29a3edb8341.png"}
                                                                alt="هنری" /></a></div>
                        <div className="has-dropdown">
                            {
                                user.id ?
                                    <React.Fragment>
                                        <img className={'mobile-header-user-icon'} src={constants.$authUrl+"/images/icon/20c1062c46f7cc30134ace3cc3823f3e.png"} alt=""/>
                                        <ul className="submenu">
                                            <li>
                                                <p>{user.name}</p>
                                                <p>{user.username}</p>
                                                <Link style={{padding: '5px 15px',
                                                    backgroundColor: '#2ccbcc',
                                                    borderRadius: 3,
                                                    color: 'white',
                                                    width: '100%',
                                                    marginRight : 0
                                                }} to={"/user/edit"} >
                                                    اطلاعات حساب من
                                                </Link>
                                            </li>
                                            <hr className={"solid mb-3"}/>
                                            <li>
                                                <span onClick={logout} className={"cursor-pointer"} >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                         fill="currentColor" className="bi bi-file-x" viewBox="0 0 16 16">
                                                        <path d="M6.146 6.146a.5.5 0 0 1 .708 0L8 7.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 8l1.147 1.146a.5.5 0 0 1-.708.708L8 8.707 6.854 9.854a.5.5 0 0 1-.708-.708L7.293 8 6.146 6.854a.5.5 0 0 1 0-.708z" />
                                                        <path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z" />
                                                    </svg>
                                                    &nbsp;&nbsp;
                                                    خروج از حساب کاربری
                                                </span>
                                            </li>
                                        </ul>
                                    </React.Fragment>
                                    :
                                    null
                                // <a href={constants.loginURL+"?site=class&callBack="+encodeURIComponent(url) }><img className={'mobile-header-user-icon'} src={constants.classNextURL+"/images/icon/20c1062c46f7cc30134ace3cc3823f3e.png"} alt=""/></a>
                            }
                        </div>

                    </div>
                </div>
            </header>
        </React.Fragment>

    )
}
